/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import {styled} from '@mui/material/styles';
import {Link as RouterLink} from 'react-router-dom';

const LinkContainer = styled('a')(({theme}) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
}));

export function Link({
  children,
  ...linkProps
}: React.ComponentProps<'a'> & {
  to?: string | {pathname: string; state: any};
}) {
  return (
    <LinkContainer as={linkProps.to ? RouterLink : 'a'} {...linkProps}>
      {children}
    </LinkContainer>
  );
}
